import { version } from "vue";
export function logEnv() {
  console.log("Current Vue version: " + version);
}
